import { render, staticRenderFns } from "./customerworkbench.vue?vue&type=template&id=4ccd4cfa&scoped=true"
import script from "./customerworkbench.vue?vue&type=script&lang=js"
export * from "./customerworkbench.vue?vue&type=script&lang=js"
import style0 from "./customerworkbench.vue?vue&type=style&index=0&id=4ccd4cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccd4cfa",
  null
  
)

export default component.exports